import { Link } from "react-router-dom";

var CurrentUser = require("lib/account/CurrentUser");
var GoogleSignIn = require("components/logins/GoogleSignIn");
var ErrorDisplay = require("components/utility/ErrorDisplay")
var LoadingButton = require("components/utility/LoadingButton");
var Router = require("react-router");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");
var RosterActions = require("lib/actions/RosterActions");

require("logins/login_page.scss");

import { connect } from "react-redux";
@connect(
	(state, props) => ({
	}),
	(dispatch, props) => ({
		fetchOrgData: () => {
			return dispatch(RosterActions.fetchOrgData({}))
		},
	})
)
class LoginPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			loading: false
		};
	}

	onSubmit(e) {
		$wr.nope(e)
		this.refs.errors.reset();

		var username = this.refs.username.value;
		var password = this.refs.password.value;

		if (username.toLowerCase().trim().startsWith("wr.")) {
			window.wrNotifications.triggerDropDownNotification({
				title: "Redirecting...",
				text: "Please log in on the Whooo's Reading homepage.",
				icon: "asterisk"
			}, 4000);

			setTimeout(() => {
				window.location.href = WhooosReadingServices.OuterPages.url("/")
			}, 4000)

			return
		}

		this.setState({ loading: true });
		CurrentUser.usernamePasswordAuthenticate(username, password, function(success, errorText) {
			if (success) {
				this.props.fetchOrgData().then(() => {
					$wr.redirect('/');					
				})
			} else {
				this.setState({ loading: false });
				this.refs.errors.setError(errorText);
			}
		}.bind(this));
	}

	render() {
		if (!($wr.isInternetExplorer() || $wr.isAppdev())) {
			var googleSignIn = (
				<div>
					<p className="text-center">Or</p>
					<GoogleSignIn />
				</div>	
			)
		}

		if (!$wr.isAppdev()) {
			var forgotPassword = (
				<p className="loginLinks">
					<Link to="/forgot_password">
						Forgot your password?
					</Link>
				</p>
			);
			var owlPath = require("misc/wise-owls.png");
			var owlCaption = "Owls are reading a lot these days!";
		} else {
			var owlPath = require("misc/wise-owl-wizard.png");
			var owlCaption = "Owls are doing magic a lot these days!";
		}

		return (
			<div className="loginPage container">
				<header className="pageHeader">
					<h1>Log In</h1>
				</header>
				<div className="col-sm-5">
					<form id="loginForm" onSubmit={ this.onSubmit }>
						<ErrorDisplay ref="errors" />

						<div className="form-group">
							<input type="text" ref="username" className="form-control" placeholder="Username or email" />
						</div>
						<div className="form-group">
							<input type="password" ref="password" className="form-control" placeholder="Password" />
						</div>

						{ forgotPassword }
						<LoadingButton className="buttonPrimary" text="Log in!" loading={ this.state.loading } />	
						{ googleSignIn }
					</form>
				</div>

				<div className="col-sm-7 loginImgSection">
					<img src={ owlPath } className="img-responsive wiseOwlsImg" />
					<p className="imgCaption">{ owlCaption }</p>
		 		</div>
			</div>
		)
	}

	componentDidMount() {
		if ($wr.getURLParameterByName("suspended") == "true") {
			this.refs.errors.setError("Your account is currently disabled. Please contact your account administrator.")

		} else if ($wr.getURLParameterByName("existing_google_account") == "true") {
			this.refs.errors.setError("You already have a Whooo's Reading account tied to your Google account. Click the 'Log in with Google' button below to log in.")

		} else if ($wr.getURLParameterByName("unsynced_google_account") == "true") {
			this.refs.errors.setError("There is no Whooo's Reading account tied to this Google account. Try another login method, or return to the Whooo's Reading homepage to sign up (teachers only).")

		} else if ($wr.getURLParameterByName("unsynced_clever_account") == "true") {
			this.refs.errors.setError("Your teacher hasn't synced your account with Clever yet. Ask your teacher to finish syncing or to contact Whooo's Reading support.")
		}
	}
};

LoginPage.WrappedComponent.propTypes = PageStrictPropTypes({
	fetchRosterData: PropTypes.func
});

module.exports = LoginPage;


// WEBPACK FOOTER //
// ./modules/components/logins/LoginPage.js